@if (formGroup) {
  <form [formGroup]="formGroup" class="flex items-center gap-3">
    <em-input
      formControlName="roas"
      [subscriptSizing]="'dynamic'"
      [step]="1"
      [label]="
        'CAMPAIGN_PERFORMANCE_FILTER_PRODUCT_PERFORMANCE_ROAS_PLACEHOLDER'
          | translate
      "
      type="number"
      class="flex-1"
    >
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-input>

    <em-input
      formControlName="costs"
      [subscriptSizing]="'dynamic'"
      [step]="1"
      [label]="
        'CAMPAIGN_PERFORMANCE_FILTER_PRODUCT_PERFORMANCE_COSTS_PLACEHOLDER'
          | translate
      "
      type="number"
      class="flex-1"
    >
      <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
    </em-input>

    <em-more-info
      class="ml-auto"
      [maxWidth]="600"
      [description]="
        'CAMPAIGN_PERFORMANCE_FILTER_PRODUCT_PERFORMANCE_DESCRIPTION'
          | translate
      "
    ></em-more-info>
  </form>
}
